import * as React from "react";
import { Post } from "../../../../interfaces";
import "./styles.scss";
import { Button, Modal } from "semantic-ui-react";
import { PostServices } from "../../../../services";
import pluralize from "pluralize";

type Props = {
  open: boolean;
  posts: Post[];
  onClose: () => void;
  onPostsDeleted: () => void;
};

export const DeletePostsModal: React.FC<Props> = ({ open, posts, onClose, onPostsDeleted }) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);

  const deletePosts = () => {
    setIsDeleting(true);
    const deletePromises = posts.map(post => PostServices.delete(post.postId));
    Promise.all(deletePromises)
      .then(onPostsDeleted)
      .finally(() => setIsDeleting(false));
  };

  const beginningOfDay = new Date();
  beginningOfDay.setHours(0, 0, 0, 0);

  return (
    <Modal open={open} onClose={onClose} size="tiny" className="secondaryModal">
      <Modal.Header>
        Are you sure you want to delete the {posts.length} selected {pluralize("post", posts.length)}?
      </Modal.Header>
      <Modal.Actions>
        <Button secondary loading={isDeleting} onClick={onClose} content="Cancel" />
        <Button primary loading={isDeleting} onClick={deletePosts} content="Delete" />
      </Modal.Actions>
    </Modal>
  );
};
